export enum RoleTypes {
    // input role types for different roles

    // ProjectExecutive = 'project executive',
    // CustomerService = 'customer service',
    // SuperAdmin = 'super admin',
    // Telemarketing = 'telemarketing',
    // Finance = 'finance',
    // ProjectCoordinator = 'project cordinator'
}